// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  artifactId: __t.u64().primaryKey().name("artifact_id"),
  buildId: __t.u64().name("build_id"),
  kind: __t.string(),
  minioRef: __t.string().name("minio_ref"),
  checksum: __t.string(),
  content: __t.string(),
});
